import React from 'react'

const FAQS = () => {


  return(
    <div><p>Welcome to FAQS.</p></div>
  )
}


export default FAQS;